import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
// Types
import PageTypes from 'types/PageTypes';
import IPage from 'models/Page';
// Components
import Accordion from 'components/Accordion';
import ConnectionsGridForm from './ConnectionsGridForm';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  questionRef: string;
  defaultExpanded?: boolean;
}

const ConnectionsGrid: FC<Props> = ({ questionRef, defaultExpanded }) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const watchedQuestions = watch('questions');
  const watchedPages = watch('pages');

  const questionIndex = watchedQuestions.findIndex((q: any) => q.ref === questionRef);
  const questionsPages = watchedPages.filter((page: IPage) => page.type === PageTypes.Question);
  const questionPageIndex = questionsPages.findIndex((page: IPage) => page.refs.includes(questionRef));
  const pageRef = watchedPages.find((page: IPage) => page.refs.includes(questionRef))?.uuid;

  if (questionIndex === undefined || questionIndex < 0) return null;

  return (
    <div>
      <Accordion
        label={`${t('labels.question')} ${questionPageIndex + 1}`} icon="help"
        previewPage="question" previewPageRef={pageRef}
        defaultExpanded={defaultExpanded}
      >
        <ConnectionsGridForm questionRef={questionRef} />
      </Accordion>
    </div>
  );
};

export default ConnectionsGrid;
